import { IMarkerOptimist } from 'src/interfaces/Marker';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { MARKER_ACTION, MARKER_STATUS } from 'src/interfaces/enums';
import TextDate from '../TextDate';
import TextTime from '../TextTime';
import NotesMenu from '../NotesMenu';
import { LoadIcon } from '../../icons';
import NotesErrorButton from '../NotesErrorButton';
import NotesButtonReloadItem from '../NotesButtonReloadItem';
import styles from './styles.module.scss';

export interface INotesListItemProps {
  note: IMarkerOptimist;
  locale?: string;
  onTimeSelect: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onRetry: () => void;
}
const NotesListItem = forwardRef<HTMLDivElement, INotesListItemProps>(
  ({ note, locale, onEdit, onDelete, onRetry, onTimeSelect }, ref) => {
    const { t } = useTranslation('common');
    const [reloadButtonVisible, setReloadButtonVisible] = useState(false);
    const styleStatus = styles[String(note?.status).toLocaleLowerCase()];

    return (
      <div ref={ref} className={classNames(styles.container, styleStatus)}>
        <header>
          <div className={styles.noteTitle}>
            <strong>
              <TextDate dateTextWithTimezone={note.updateDate} locale={locale} />
            </strong>
            <button
              className={styles.buttonTime}
              type='button'
              onClick={onTimeSelect}
              onMouseDown={(event) => event.preventDefault()}
            >
              <TextTime time={note.time} />
            </button>
          </div>
          <NotesMenu
            disabled={note?.status === MARKER_STATUS.PENDING || note?.status === MARKER_STATUS.ERROR}
            onDelete={onDelete}
            onEdit={onEdit}
          />
        </header>
        <div className={styles.noteContent}>{note.text}</div>
        <footer className={styleStatus}>
          {note.status === MARKER_STATUS.PENDING && (
            <span className={classNames(styles.iconContainer, styles.loadingContainer)}>
              <LoadIcon />
            </span>
          )}
          {note.status === MARKER_STATUS.ERROR && (
            <span className={classNames(styles.iconContainer, styles.errorIconContainer)}>
              <NotesErrorButton
                tooltipText={
                  note?.action === MARKER_ACTION.DELETE ? t('notes.unable_to_delete') : t('notes.unable_to_save')
                }
                onClick={() => {
                  setReloadButtonVisible(true);
                }}
              />
            </span>
          )}
        </footer>
        {reloadButtonVisible && (
          <div className={styles.containerButtonReload}>
            <NotesButtonReloadItem
              onClick={() => {
                setReloadButtonVisible(false);
                onRetry();
              }}
            />
          </div>
        )}
      </div>
    );
  },
);

NotesListItem.displayName = 'NotesListItem';

export default NotesListItem;
